import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { deepCloneObject } from '../../../global/js/utils/deepCloneObject'; // Determines if a row or column header cell should receive a highlight/active background color
// Check each object in selectionAreas and see if the headerIndex is between
// point1.row and point2.row, inclusive

export var checkActiveHeaderCell = function checkActiveHeaderCell(headerIndex, selectionAreas, headerType) {
  var areasCloned = deepCloneObject(selectionAreas);
  var activeRowIndexes = [];
  areasCloned.forEach(function (area) {
    var _area$point, _area$point2, _area$point3, _area$point4;

    var greatestRowIndex = Math.max((_area$point = area.point1) === null || _area$point === void 0 ? void 0 : _area$point[headerType], (_area$point2 = area.point2) === null || _area$point2 === void 0 ? void 0 : _area$point2[headerType]);
    var lowestRowIndex = Math.min((_area$point3 = area.point1) === null || _area$point3 === void 0 ? void 0 : _area$point3[headerType], (_area$point4 = area.point2) === null || _area$point4 === void 0 ? void 0 : _area$point4[headerType]);

    for (var i = lowestRowIndex; i <= greatestRowIndex; i++) {
      activeRowIndexes.push(i);
    }
  });

  var activeRowIndexesNoDuplicates = _toConsumableArray(new Set(activeRowIndexes));

  if (areasCloned !== null && areasCloned !== void 0 && areasCloned.length && activeRowIndexesNoDuplicates.includes(headerIndex)) {
    return true;
  }

  return false;
};